import { CapoPlugin } from "/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];